import { Profile } from "@/schema/Profile";
import { atom, useAtom, useAtomValue } from "jotai";

const profileAtom = atom(undefined as Profile | undefined);
const isRoleZeroAtom = atom((get) => get(profileAtom)?.role === 0);
const roleAtom = atom((get) => get(profileAtom)?.role);

function useProfile() {
  const [profile, setProfile] = useAtom(profileAtom);
  const isRoleZero = useAtomValue(isRoleZeroAtom);
  const role = useAtomValue(roleAtom);
  return {
    profile,
    setProfile,
    isRoleZero,
    role,
  };
}

export default useProfile;
